export const INCREMENT_VC = "INCREMENT_VC";
export const INCREMENT_TC = "INCREMENT_TC";
export const RESET_TC = "RESET_TC";
export const RESET_VC = "RESET_VC";
export const SHOW_SHIFT_TIMECARD_MODAL = "SHOW_SHIFT_TIMECARD_MODAL";
export const HIDE_SHIFT_TIMECARD_MODAL = "HIDE_SHIFT_TIMECARD_MODAL";

const initialState = {
  timecardsListPreview: [],
  verifiedCounter: 0,
  timecardCounter: 0,
};

/**
 * Redux state management and other boilerplate code is painful to manage and hinders discoverability.
 * Redux code guidelines show this bizarre pattern with initializing function arguments
 * without a default for the action. Example:
 * https://redux.js.org/usage/structuring-reducers/initializing-state#single-simple-reducer
 * This is linted against via typical lint rules.
 * Unfortunately, redux recommends this, so we need to mark the lint rule as disabled until
 * we eliminate redux from the code base.
 * https://linear.app/clipboardhealth/issue/FEF-167/deprecate-redux
 */
// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case INCREMENT_VC:
      return {
        ...state,
        verifiedCounter: state.verifiedCounter + 1,
      };

    case INCREMENT_TC:
      return {
        ...state,
        timecardCounter: state.timecardCounter + 1,
      };

    case RESET_TC:
      return {
        ...state,
        timecardCounter: 0,
      };
    case RESET_VC:
      return {
        ...state,
        verifiedCounter: 0,
      };
    case SHOW_SHIFT_TIMECARD_MODAL: {
      return {
        ...state,
        timecardsListPreview: action.timecards,
      };
    }
    case HIDE_SHIFT_TIMECARD_MODAL: {
      return {
        ...state,
        timecardsListPreview: [],
      };
    }
    default:
      return state;
  }
};

export const incrementVC = () => {
  return (dispatch) => {
    dispatch({
      type: INCREMENT_VC,
    });
  };
};

export const incrementTC = () => {
  return (dispatch) => {
    dispatch({
      type: INCREMENT_TC,
    });
  };
};

export const resetTC = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_TC,
    });
  };
};

export const resetVC = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_VC,
    });
  };
};
